import {
  IRequirementResponse,
  PayeeTaxDocumentSharePermission,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { CustomRequirement, RequirementStatusViewProps } from "../../../types";

export function getShareConsentCustomRequirement(
  requirements: IRequirementResponse[],
  openConsentModal: () => void
): CustomRequirement {
  const baseRequirement = requirements[0];

  const completeRequirementsCount = requirements.filter(
    requirement => requirement.status === RequirementStatus.Complete
  ).length;

  const allRequirementsComplete = requirements.every(
    requirement => requirement.status === RequirementStatus.Complete
  );

  const allConsentsShared = requirements.every(
    requirement =>
      (requirement.dataSourceMetadata?.payeeOwnedData?.shareTaxDocument as
        | PayeeTaxDocumentSharePermission
        | undefined) === PayeeTaxDocumentSharePermission.Allow
  );

  const status =
    allRequirementsComplete || allConsentsShared
      ? RequirementStatus.Complete
      : RequirementStatus.Incomplete;

  return {
    payerId: baseRequirement.payerId,
    status,
    nameCell: {
      text: "Consent to share information"
    },
    typeCell: {
      icon: "clipboard-check",
      text: "Info sharing"
    },
    clientsCell:
      // If there is only one requirement, don't put clients cell, it will display client name in the table
      requirements.length === 1
        ? undefined
        : {
            text: `${requirements.length} clients`
          },
    engagementsCell: {},
    statusCell: getStatusCell(
      status,
      completeRequirementsCount,
      requirements.length
    ),
    menuActions:
      status === RequirementStatus.Incomplete
        ? [
            {
              label: "Consent to share information",
              icon: "clipboard-check",
              onClick: openConsentModal
            }
          ]
        : []
  };
}

const getStatusCell = (
  status: RequirementStatus,
  numberComplete: number,
  numberTotal: number
): RequirementStatusViewProps => {
  const secondaryText = `Shared with ${numberComplete} of ${numberTotal} clients`;

  switch (status) {
    case RequirementStatus.Complete:
      return {
        pill: {
          text: "Complete",
          theme: "success",
          icon: true
        },
        secondaryText
      };
    default:
      return {
        pill: {
          theme: "warning",
          text: "Action required",
          icon: true
        },
        secondaryText
      };
  }
};
